module.exports = __webpack_public_path__ + "img/1527250405.23b3a314.jpg";